export enum AuthStates {
  SUCCESS = 'Success',
  LOYALTY_NOT_FOUND = 'LoyaltyNotFound',
  SETUR_NOTFOUND = 'SeturNotfound',
}
